"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pin = exports.pinCustomizableTypes = exports.pinInteractiveTypes = exports.allPinTypes = void 0;
const lodash_1 = __importDefault(require("lodash"));
const PinUtils_1 = require("./PinUtils");
const pins_shared_1 = require("@lessonup/pins-shared");
exports.allPinTypes = pins_shared_1.allPinTypes;
exports.pinInteractiveTypes = [
    'MULTIPLE_CHOICE',
    'OPEN_QUESTION',
    'WORD_CLOUD',
    'DRAG_QUESTION',
    'POLL',
];
exports.pinCustomizableTypes = [
    'SLIDE',
    'MULTIPLE_CHOICE',
    'OPEN_QUESTION',
    'WORD_CLOUD',
    'POLL',
    'DRAG_QUESTION',
];
const pinTypeEventNames = [
    'DRAG_AND_DROP',
    'LINK',
    'MAP',
    'OPEN_QUESTION',
    'POLL',
    'MULTIPLE_CHOICE',
    'SLIDE',
    'VIDEO',
    'WORD_CLOUD',
];
const pinTypeToPinTypeForEvent = {
    DRAG_QUESTION: 'DRAG_AND_DROP',
    LINK: 'LINK',
    MAP: 'MAP',
    OPEN_QUESTION: 'OPEN_QUESTION',
    POLL: 'POLL',
    MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
    SLIDE: 'SLIDE',
    VIDEO: 'VIDEO',
    WORD_CLOUD: 'WORD_CLOUD',
};
var Pin;
(function (Pin) {
    // TODO: Remove?
    // export function getContent<T extends Record<string, any>>(pin: Pin | undefined): T | undefined {
    //   return pin && pin.item.custom;
    // }
    function filterList(list, pinFilter) {
        return list.filter((p) => pinFilter.includes(p.type));
    }
    Pin.filterList = filterList;
    function isOfType(pin, ...types) {
        return types.includes(pin.type);
    }
    Pin.isOfType = isOfType;
    // TODO: Remove (moved to root level)
    // export function isItemOfType<T extends PinItem>(item: T, ...types: PinType[]): boolean {
    //   return types.includes(item.type);
    // }
    function pinTypeToEventName(pinType) {
        return pinTypeToPinTypeForEvent[pinType];
    }
    Pin.pinTypeToEventName = pinTypeToEventName;
    Pin.aspectRatio = {
        width: 1.6,
        height: 0.9,
    };
    // TODO @davey
    /** returns undefined if there are no child pins possible */
    // export function childrenForPin<P extends Pin>(pin: P, otherPins: P[]): P[] | undefined {
    //   if (!Video.isInteractiveVideo(pin) || !pin.item.videoItems) {
    //     return undefined;
    //   }
    //   const childIds = pin.item.videoItems.map((i) => i.pinId);
    //   return _.filter(otherPins, (p) => childIds.includes(p.id));
    // }
    function hasInteractiveChildren(pin, allPins) {
        if (pin.type !== 'VIDEO') {
            return false;
        }
        return lodash_1.default.some(pin.settings.videoItems, (videoItem) => {
            const childPin = allPins.find((p) => p.id === videoItem.pinId);
            return childPin && isInteractive(childPin);
        });
    }
    Pin.hasInteractiveChildren = hasInteractiveChildren;
    function withoutChildPins(pins) {
        return lodash_1.default.filter(pins, (p) => !isChildPin(p));
    }
    Pin.withoutChildPins = withoutChildPins;
    function isChildPin(pin) {
        return !lodash_1.default.isNil(pin.parentPinId);
    }
    Pin.isChildPin = isChildPin;
    function isInteractive(pin) {
        return PinUtils_1.PinUtils.isInteractive(pin);
    }
    Pin.isInteractive = isInteractive;
    function isCustomizable(pin) {
        return exports.pinCustomizableTypes.includes(pin.type);
    }
    Pin.isCustomizable = isCustomizable;
    function onlyInteractivePins(pins) {
        return lodash_1.default.filter(pins, (p) => isInteractive(p));
    }
    Pin.onlyInteractivePins = onlyInteractivePins;
    function sorted(pins) {
        return pins.sort(pins_shared_1.orderableCompareFn);
    }
    Pin.sorted = sorted;
    function isPhotoQuestion(pin) {
        // TODO: Fix if reimplementing
        // return isOfType(pin, 'OPEN_QUESTION') && 'studentImage' in pin.item.custom;
        return false;
    }
    Pin.isPhotoQuestion = isPhotoQuestion;
    function isInteractiveVideo(pin) {
        return pin.type === 'VIDEO' && pin.settings.interactive;
    }
    Pin.isInteractiveVideo = isInteractiveVideo;
    function isRestrictedPin(pin) {
        return (isPhotoQuestion(pin) ||
            isOfType(pin, 'DRAG_QUESTION') ||
            isOfType(pin, 'POLL') ||
            isInteractiveVideo(pin) ||
            isChildPin(pin));
    }
    Pin.isRestrictedPin = isRestrictedPin;
    // TODO @davey: Replace call site with newSlide()
    /**
     * @description Creates a default first pin for a newly created lesson. Only works with slides at the moment.
     */
    // export function defaultFirstPinForLesson(options: DefaultFirstPinOptions): WithOptionalId<LessonPin> {
    //   return {
    //     user: options.userId,
    //     creationDate: new Date(),
    //     lesson: options.lessonId,
    //     item: {
    //       type: options.type,
    //       custom: {
    //         text1: options.question,
    //         type: 'SLIDE',
    //         layout: 1,
    //         font1: options.preferredFont,
    //         font2: options.preferredFont,
    //       },
    //     },
    //     isPublic: !options.isPrivate,
    //     order: 1001,
    //     shouldIndex: undefined,
    //     isFirstPin: true,
    //   };
    // }
})(Pin || (exports.Pin = Pin = {}));
//# sourceMappingURL=Pin.js.map